import { Bell, Building2, CheckCircle2, Cloud, History, KeyRound, MonitorSmartphone, Settings, Users } from "lucide-react";
import type { Notify } from "./admin-types";
import { Header, EmptyState } from "./AdminPagePrimitives";
import { OverviewPage } from "./OverviewPage";
import { RolesPage } from "./RolesPage";
import { DepartmentsPage } from "./DepartmentsPage";
import { WorkflowsPage } from "./WorkflowsPage";
import { IntegrationPage } from "./IntegrationPage";
import { NotificationsPage } from "./NotificationsPage";
import { SessionsPage } from "./SessionsPage";
import { AuditPage } from "./AuditPage";

export function AdminConsole({
  page,
  notify,
}: {
  page: string;
  notify: Notify;
}) {
  switch (page) {
    case "Sistem Genel Bakış":
      return <OverviewPage notify={notify} />;
    case "Roller ve Yetkiler":
      return <RolesPage notify={notify} />;
    case "Departmanlar":
      return <DepartmentsPage notify={notify} />;
    case "Onay Akışları":
      return <WorkflowsPage notify={notify} />;
    case "Microsoft 365":
      return <IntegrationPage notify={notify} />;
    case "E-posta Bildirimleri":
      return <NotificationsPage notify={notify} />;
    case "Aktif Oturumlar":
      return <SessionsPage notify={notify} />;
    case "Güvenlik Kayıtları":
      return <AuditPage notify={notify} />;
    default:
      return (
        <>
          <Header
            eyebrow="Sistem yönetimi"
            title="Yönetim alanı"
            description="Bu yönetim sayfası için görünüm bulunamadı."
          />
          <EmptyState
            title="Sayfa bulunamadı"
            description="Sol menüden yetkiniz kapsamındaki bir yönetim sayfası seçin."
          />
        </>
      );
  }
}

export const adminNavigation = [
  { label: "Sistem Genel Bakış", icon: MonitorSmartphone },
  { label: "Personel ve Erişim Merkezi", icon: KeyRound },
  { label: "Kullanıcılar", icon: Users },
  { label: "Roller ve Yetkiler", icon: KeyRound },
  { label: "Departmanlar", icon: Building2 },
  { label: "Onay Akışları", icon: CheckCircle2 },
  { label: "Microsoft 365", icon: Cloud },
  { label: "E-posta Bildirimleri", icon: Bell },
  { label: "Aktif Oturumlar", icon: MonitorSmartphone },
  { label: "Güvenlik Kayıtları", icon: History },
  { label: "Sistem Ayarları", icon: Settings },
];
